import React, { useEffect, useState } from "react";

import { Link, useLocation, useSearchParams } from "react-router-dom";
import Toggle from "react-toggle";
import { useTheme } from "../../context/ThemeContext";

import NotificationsComponent from "../Notifications/NotificationsComponent";
import UserAccountInfo from "../UserAccountInfo";

import sun from "../../images/sun.png";
import moon from "../../images/moon.png";
import SystemInfo from "../../util/SystemInfo";

const Header = ({ onNote }) => {

    const { season } = useTheme();

    const { changeBackground } = useTheme();

    const location = useLocation();

    const [searchParams] = useSearchParams();

    const [darkMode, setDarkMode] = useState(false);

    const [nameForUpdate, setNameForUpdate] = useState('');

    useEffect(() => {
        const dark = localStorage.getItem('CSI-PEDIDOS-DARKMODE') === 'true' ? true : false;
        setDarkMode(dark);
    }, []);

    useEffect(() => {
        if (nameForUpdate) {
            document.title = `${SystemInfo?.name} - ${nameForUpdate}`;
        } else {
            document.title = SystemInfo?.name;
        }
    }, [nameForUpdate])

    useEffect(() => {
        setNameForUpdate(searchParams?.get('name'));
    }, [searchParams])

    useEffect(() => {
        if (darkMode) {
            changeBackground({ value: "dark", label: "dark" });
        } else {
            changeBackground({ value: "light", label: "light" });
        }

        localStorage.setItem('CSI-PEDIDOS-DARKMODE', darkMode);
    }, [darkMode]);

    // Diccionario de imágenes por temporada
    const bannerImages = {
        'christmas': 'https://base-csi.s3.us-east-2.amazonaws.com/pedidos/public/product-images/banner-navidad.jpg',
        'newyear': 'https://img.freepik.com/free-vector/golden-new-year-banner_1017-16185.jpg',
        'cyber': 'https://img.freepik.com/free-vector/cyber-monday-sale-banner_23-2148659804.jpg'
    };

    return (
        <div className="header">
            <div className="header-content">
                <nav className="navbar navbar-expand">
              <div className="collapse navbar-collapse justify-content-between">
                        
                        {/* 1. IZQUIERDA: Título Dashboard */}
                        <div className="header-left">
                            <div className="dashboard_bar" style={{ textTransform: "capitalize" }}>
                                {
                                    nameForUpdate ?
                                        `${location?.pathname?.split?.('/')?.filter?.((value) => { if (value) return value; })[0]} - ${nameForUpdate.length > 16 ? `${nameForUpdate.slice(0, 16)}...` : nameForUpdate}`
                                        :
                                        location?.pathname?.split?.('/')?.filter?.((value) => { if (value) return value; }).join(' - ')
                                }
                            </div>
                        </div>

                        {/* 2. CENTRO: EL BANNER (NUEVO CÓDIGO FLEXBOX) */}
                        {/* Este bloque va FUERA del header-left pero ANTES del header-right */}
                       {season !== 'none' && bannerImages[season] && (
                            <div className="d-none d-lg-flex flex-grow-1 justify-content-center align-items-center mx-3" style={{ height: '100%' }}>
                                <img
                                    src={bannerImages[season]}
                                    alt="Banner Temporada"
                                    style={{
                                        height: '80px',        // 👈 CAMBIO: Aumentamos la altura (antes 55px)
                                        width: '100%',         // Intenta llenar el ancho
                                        maxWidth: '700px',     // 👈 CAMBIO: Permitimos que sea más ancho (antes 500px)
                                        objectFit: 'contain',  // Ajusta sin recortar
                                        borderRadius: '8px'
                                    }}
                                />
                            </div>
                        )}

                        {/* 3. DERECHA: Iconos (Campana, Sol, Perfil) */}
                        <ul className="navbar-nav header-right main-notification" style={{ alignItems: "center" }}>
                            {/* ... (Aquí sigue tu código de notificaciones, input, etc. No hace falta cambiarlo) ... */}
                            <li className="nav-item" style={{ margin: '0 10px' }}>
                               <div className="input-group search-area"></div>
                            </li>
                            <NotificationsComponent />
                            <div style={{ margin: '0 30px', display: 'flex', alignItems: 'center' }}>
                                {/* ... Tus iconos de Sol/Luna ... */}
                                {!darkMode ? <img className="d-none d-sm-block" style={{ maxWidth: '40px', marginRight: 10 }} src={sun} alt="" /> : null}
                                <Toggle onChange={() => { setDarkMode((oldDarkMode) => !oldDarkMode) }} checked={darkMode} />
                                {darkMode ? <img className="d-none d-sm-block" style={{ maxWidth: '40px', marginLeft: 10 }} src={moon} alt="" /> : null}
                            </div>
                            <UserAccountInfo />
                        </ul>

                    </div>
                </nav>
            </div>
        </div>
    );
};

export default Header;
